import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Trophy } from "@phosphor-icons/react";
import api from "../lib/api";

// Pseudo public et participation volontaire au classement (audit conformité F9).
// Le nom réel n'est jamais affiché dans les classements ni dans les annonces de gagnants.
export default function PublicProfileSection() {
  const { t } = useTranslation();
  const [pseudo, setPseudo] = useState("");
  const [optIn, setOptIn] = useState(false);
  const [rulesAccepted, setRulesAccepted] = useState(false);
  const [rulesOk, setRulesOk] = useState(false);
  const [blocked, setBlocked] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/profile").then((r) => {
      setPseudo(r.data?.public_name || "");
      setOptIn(!!r.data?.leaderboard_opt_in);
      setRulesAccepted(!!r.data?.community_rules_accepted);
      setLoaded(true);
    }).catch(() => setLoaded(true));
    api.get("/blocks").then((r) => setBlocked(r.data?.blocked || [])).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/profile", { public_name: pseudo.trim(), leaderboard_opt_in: optIn,
        accept_community_rules: rulesAccepted || rulesOk });
      if (rulesOk) setRulesAccepted(true);
      toast.success(t("account.saved"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("account.error"));
    } finally {
      setBusy(false);
    }
  };

  if (!loaded) return null;
  return (
    <form onSubmit={save} className="hm-card p-5 mt-4" data-testid="account-public-profile">
      <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-white/60 mb-4">
        <Trophy size={17} weight="bold" color="#D4AF37" /> {t("account.public_title")}
      </p>
      <label htmlFor="public-name" className="block text-xs text-white/60 mb-1.5">{t("account.public_name")}</label>
      <input id="public-name" value={pseudo} onChange={(e) => setPseudo(e.target.value)} maxLength={20}
        className="w-full h-11 px-3.5 rounded-xl bg-white/5 border border-white/10 text-sm text-white focus:outline-none focus:border-gold/60 mb-1"
        data-testid="account-public-name" />
      <p className="text-[11px] text-white/45 mb-3">{t("account.public_name_hint")}</p>
      <label className="flex items-start gap-3 text-sm text-white/80 mb-4 cursor-pointer">
        <input type="checkbox" checked={optIn} onChange={(e) => setOptIn(e.target.checked)} className="mt-1"
          data-testid="account-leaderboard-optin" />
        <span>{t("account.leaderboard_optin")}</span>
      </label>
      {!rulesAccepted && (
        <label className="flex items-start gap-3 text-sm text-white/80 mb-4 cursor-pointer">
          <input type="checkbox" checked={rulesOk} onChange={(e) => setRulesOk(e.target.checked)} className="mt-1"
            data-testid="account-rules-check" />
          <span>{t("community.accept_prefix")} <a href="/regles-communaute" className="underline">{t("community.rules_link")}</a>.</span>
        </label>
      )}
      {blocked.length > 0 && (
        <div className="mb-4" data-testid="account-blocked-list">
          <p className="text-xs text-white/60 mb-1.5">{t("community.blocked_title")}</p>
          {blocked.map((b) => (
            <div key={b.user_id} className="flex items-center justify-between text-sm py-1">
              <span>{b.name}</span>
              <button type="button" className="text-xs underline text-white/60"
                onClick={() => api.delete(`/blocks/${b.user_id}`).then(() => setBlocked((l) => l.filter((x) => x.user_id !== b.user_id)))}>
                {t("community.unblock")}
              </button>
            </div>
          ))}
        </div>
      )}
      <button type="submit" disabled={busy}
        className="w-full h-11 rounded-xl bg-gold text-black font-bold text-sm hover:bg-gold/90 transition-colors disabled:opacity-60"
        data-testid="account-public-save">{t("account.save")}</button>
    </form>
  );
}
